<template>
  <div>
    <svg
      :style="{
        width: width || '40px',
        height: height || '40px',
      }"
      width="800px"
      height="800px"
      viewBox="-36.5 0 316 316"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>000-Balloon</title>
      <desc>Created with Sketch.</desc>
      <defs></defs>
      <g
        id="Page-1"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Artboard" transform="translate(-131.000000, -130.000000)">
          <g id="000-Balloon" transform="translate(131.000000, 130.000000)">
            <path
              d="M53.7021,214.2714 C53.7021,214.2714 97.3001,204.5184 112.8431,193.2144 C133.7401,178.0174 149.3871,144.5904 181.7931,139.9564 C203.6501,136.8314 231.0861,184.4434 231.0861,184.4434 L229.7321,188.9114 C229.7321,188.9114 197.4611,176.6414 172.2761,183.7604 C152.7711,189.2734 132.6431,213.2844 111.1891,221.6244 C76.1761,235.2364 53.7021,214.2714 53.7021,214.2714 Z"
              id="Fill-2"
              fill="#8B9A70"
            ></path>
            <path
              d="M53.7021,214.2714 C53.7021,214.2714 76.0451,230.2384 111.0581,216.6264 C132.5121,208.2854 152.6401,184.2754 172.1451,178.7614 C197.3301,171.6434 231.0861,184.4434 231.0861,184.4434 C231.0861,184.4434 207.7631,131.2264 181.6621,134.9584 C149.2561,139.5914 133.6091,173.0184 112.7121,188.2154 C93.5441,202.1554 53.7021,214.2714 53.7021,214.2714"
              id="Fill-4"
              fill="#99A880"
            ></path>
            <path
              d="M63.6361,220.7841 C63.6361,220.7841 91.3341,236.3641 125.0751,215.3261 C145.7491,202.4351 161.8551,174.4931 181.0721,164.8001 C205.8861,152.2831 242.0301,157.1911 242.0301,157.1911 L242.5331,152.5191 C242.5331,152.5191 204.2431,111.9411 182.0881,119.8141 C149.2391,131.4861 139.7211,167.6621 121.0221,187.1431 C107.1131,201.6341 63.6361,220.7841 63.6361,220.7841"
              id="Fill-6"
              fill="#8B9A70"
            ></path>
            <path
              d="M63.6361,220.7841 C63.6361,220.7841 90.1811,231.4981 123.9221,210.4601 C144.5961,197.5691 160.7021,169.6271 179.9191,159.9341 C204.7331,147.4181 242.5331,152.5191 242.5331,152.5191 C242.5331,152.5191 207.3921,105.5471 180.9351,114.9481 C148.0861,126.6211 138.5681,162.7961 119.8691,182.2781 C102.7171,200.1481 63.6361,220.7841 63.6361,220.7841"
              id="Fill-8"
              fill="#99A880"
            ></path>
            <path
              d="M69.0498,174.1871 C47.2998,188.2921 40.5618,188.0411 40.4868,194.3131 C40.3038,209.5841 79.6798,243.8731 110.7998,209.0841 C120.6878,198.0301 124.5648,184.1901 119.5978,178.9481 C114.6308,173.7061 90.7998,160.0821 69.0498,174.1871"
              id="Fill-10"
              fill="#99A880"
            ></path>
            <path
              d="M68.0986,166.3342 C46.3486,180.4392 43.7856,197.5492 43.7856,197.5492 C43.7856,197.5492 72.4786,230.8732 103.5986,196.0842 C113.4866,185.0302 121.3156,166.5762 116.3486,161.3342 C111.3816,156.0922 89.8486,152.2292 68.0986,166.3342"
              id="Fill-12"
              fill="#8B9A70"
            ></path>
            <path
              d="M63.0983,161.3339 C41.3483,175.4389 38.7853,192.5489 38.7853,192.5489 C38.7853,192.5489 67.4783,225.8729 98.5983,191.0839 C108.4863,180.0299 116.3153,161.5759 111.3483,156.3339 C106.3813,151.0919 84.8483,147.2289 63.0983,161.3339"
              id="Fill-14"
              fill="#99A880"
            ></path>
            <path
              d="M76.8271,44.2515 C78.1221,16.8735 69.6131,0.2265 65.8861,0.2165 C62.3671,0.2065 50.3471,26.4625 48.6901,52.3465 C47.2341,75.0775 56.4151,95.1825 62.3451,93.8015 C65.5971,93.0445 75.6431,69.2725 76.8271,44.2515"
              id="Fill-16"
              fill="#F2BD86"
            ></path>
            <path
              d="M134.0497,39.0839 C130.9757,34.4169 115.2747,21.1789 105.2457,21.1789 C95.2167,21.1789 82.1897,22.7509 75.0497,25.5839 C67.9097,28.4169 57.0997,37.9879 57.0997,37.9879 L148.3827,113.0839 C148.3827,113.0839 151.4867,88.0129 151.0317,77.8829 C150.5767,67.7529 137.1237,43.7509 134.0497,39.0839"
              id="Fill-18"
              fill="#A26764"
            ></path>
            <path
              d="M63.1386,33.0474 C59.6746,35.7094 57.0996,37.9874 57.0996,37.9874 L92.6386,66.5904 L131.4626,83.8734 L137.2166,74.3614 C115.0956,25.8394 79.0136,28.8764 63.1386,33.0474"
              id="Fill-20"
              fill="#684345"
            ></path>
            <path
              d="M51.8687,60.7107 C51.8687,60.7107 -27.0793,148.7867 9.9107,181.7227 C61.7197,227.8547 142.6867,129.6387 142.6867,129.6387 L51.8687,60.7107 Z"
              id="Fill-22"
              fill="#DEA672"
            ></path>
            <path
              d="M5.0376,176.0995 C53.4686,218.1165 126.8336,135.7415 136.2496,124.7535 L86.2996,40.0835 L51.8686,60.7105 C51.8686,60.7105 -18.9984,139.7835 5.0376,176.0995"
              id="Fill-24"
              fill="#F2BD86"
            ></path>
            <path
              d="M19.7061,163.7443 C17.8041,163.4603 12.2711,154.4543 7.3131,157.0423 C3.1591,159.2123 11.6111,175.3063 18.0431,176.7683 C24.4741,178.2303 36.0191,169.9683 33.0661,163.6933 C30.5721,158.3923 21.6081,164.0283 19.7061,163.7443"
              id="Fill-26"
              fill="#343635"
            ></path>
            <path
              d="M47.2148,103.071 C49.6538,96.801 48.6188,90.547 44.9028,89.101 C41.1878,87.656 36.1978,91.566 33.7588,97.836 C31.3198,104.105 32.3548,110.36 36.0698,111.805 C39.7858,113.251 44.7758,109.341 47.2148,103.071"
              id="Fill-28"
              fill="#343635"
            ></path>
            <path
              d="M77.525,111.6385 C79.964,105.3685 78.929,99.1145 75.213,97.6685 C71.498,96.2235 66.508,100.1335 64.069,106.4035 C61.63,112.6725 62.665,118.9275 66.38,120.3725 C70.096,121.8185 75.086,117.9085 77.525,111.6385"
              id="Fill-30"
              fill="#343635"
            ></path>
            <path
              d="M117.7097,100.2506 L111.5427,100.1546 C100.4847,111.7566 112.4077,126.6246 112.4077,126.6246 C112.4077,126.6246 100.6127,120.8966 95.9997,129.7086 C92.1457,137.0686 101.9047,145.8266 101.9047,145.8266 C101.9047,145.8266 91.1777,141.2726 87.6937,147.5836 C82.9327,156.2086 90.9977,163.2316 90.9977,163.2316 C90.9977,163.2316 83.5497,160.1126 80.7237,168.4176 C76.9547,179.4956 94.2107,187.9486 94.2107,187.9486 L94.7167,185.1676 L128.4627,116.6426 L117.7097,100.2506 Z"
              id="Fill-32"
              fill="#DADBD7"
            ></path>
            <path
              d="M120.7099,99.2505 L114.5429,99.1545 C103.4849,110.7565 116.6989,128.8815 116.6989,128.8815 C116.6989,128.8815 103.5519,120.1765 98.9999,128.7085 C94.4469,137.2395 106.6159,147.9725 106.6159,147.9725 C106.6159,147.9725 93.9949,140.9035 90.6939,146.5835 C85.0779,156.2505 94.3209,163.9895 94.3209,163.9895 C94.3209,163.9895 86.5319,160.7335 83.7239,167.4175 C79.3829,177.7505 94.3209,184.9855 94.3209,184.9855 L99.5499,184.2505 L131.4629,115.6425 L120.7099,99.2505 Z"
              id="Fill-34"
              fill="#F0F0ED"
            ></path>
            <path
              d="M87.9234,40.1232 C67.4234,63.6232 67.5254,94.9192 99.0494,115.5842 C101.7724,117.3692 130.9944,77.8002 130.0384,74.6802 C121.3834,46.4172 87.9234,40.1232 87.9234,40.1232"
              id="Fill-36"
              fill="#994D65"
            ></path>
            <path
              d="M91.574,40.9768 C72.001,66.0008 73.078,92.3328 101.905,112.6668 C104.566,114.5438 130.994,77.7998 130.039,74.6798 C121.383,46.4168 91.574,40.9768 91.574,40.9768"
              id="Fill-38"
              fill="#B55D75"
            ></path>
            <path
              d="M94.434,49.1042 C79.295,68.4592 78.824,87.0152 101.122,102.7432 C103.18,104.1952 123.622,75.7742 122.883,73.3612 C116.188,51.5002 94.434,49.1042 94.434,49.1042"
              id="Fill-40"
              fill="#D8D9D4"
            ></path>
            <path
              d="M87.9234,40.1232 C87.9234,40.1232 76.5184,58.2482 58.7774,72.7092 C46.0494,83.0842 30.2644,84.1202 30.0494,83.8342 C28.9244,82.3342 29.4294,79.2492 30.4274,78.5662 C31.4244,77.8832 51.9234,81.5422 83.7244,37.5482 L87.9234,40.1232 Z"
              id="Fill-42"
              fill="#994D65"
            ></path>
            <path
              d="M50.3748,39.079 C47.7998,40.123 30.4268,78.566 30.4268,78.566 C51.9238,80.251 85.2168,38.463 83.7238,37.548 C80.2138,35.395 52.9498,38.035 50.3748,39.079"
              id="Fill-44"
              fill="#B55D75"
            ></path>
            <path
              d="M32.8054,73.3611 C50.4814,71.4011 74.3854,43.2061 73.2174,42.4891 C70.7304,40.9641 53.5484,42.6361 47.2534,43.6961 C43.1424,51.1141 36.3774,65.5981 32.8054,73.3611"
              id="Fill-46"
              fill="#D8D9D4"
            ></path>
            <path
              d="M173.3726,88.3278 C192.3586,67.3568 194.7756,43.1278 191.1226,38.5178 C187.6736,34.1648 158.8826,40.9708 140.5076,60.2628 C124.3706,77.2048 120.3746,105.1138 127.0916,111.2968 C130.7746,114.6868 156.0206,107.4938 173.3726,88.3278"
              id="Fill-48"
              fill="#DEA672"
            ></path>
            <path
              d="M192.5457,45.9234 C192.5267,45.8954 192.5107,45.8594 192.4907,45.8334 C189.2157,41.3474 160.1797,47.0154 141.0587,65.5694 C132.1517,74.2124 126.5377,86.0744 124.1947,96.2694 C123.5077,103.2644 124.4957,108.9064 127.0917,111.2974 C130.7747,114.6874 156.0207,107.4934 173.3727,88.3274 C187.3167,72.9264 192.3167,55.7774 192.5457,45.9234"
              id="Fill-50"
              fill="#F2BD86"
            ></path>
            <path
              d="M80.2411,36.8443 C81.3141,36.2613 92.3251,38.7843 94.3211,40.0843 C94.4951,40.1973 94.5471,41.6373 94.5401,41.7103 C94.4141,42.9573 90.2551,49.4593 89.3091,49.8343 C88.3621,50.2093 76.2371,45.5213 75.8621,44.6463 C75.7931,44.4853 75.7021,43.1073 75.8621,42.6463 C76.5711,40.6103 79.2901,37.3613 80.2411,36.8443"
              id="Fill-52"
              fill="#684345"
            ></path>
            <path
              d="M80.2411,34.8442 C81.4071,34.2102 93.9221,39.0432 94.2981,39.8762 C94.6751,40.7092 90.2551,47.4592 89.3091,47.8342 C88.3621,48.2092 76.2371,43.5212 75.8621,42.6462 C75.4871,41.7712 79.0751,35.4782 80.2411,34.8442"
              id="Fill-54"
              fill="#A26764"
            ></path>
            <path
              d="M125.8738,116.5893 C124.3828,116.5893 75.0018,190.2053 102.7168,201.0843 C136.0498,214.1673 140.3088,141.0423 141.0008,138.3963 C141.6938,135.7503 127.3648,116.5893 125.8738,116.5893"
              id="Fill-56"
              fill="#684345"
            ></path>
            <path
              d="M128.874,117.5894 C127.383,117.5894 78.02,191.1994 105.924,201.5844 C133.828,211.9684 143.309,142.0424 144.001,139.3964 C144.694,136.7504 130.365,117.5894 128.874,117.5894"
              id="Fill-58"
              fill="#A26764"
            ></path>
            <path
              d="M129.2656,77.0649 L114.5426,99.1549 C114.5426,99.1549 133.8606,131.5839 142.5376,141.3339 C143.5326,142.4519 145.1576,140.6229 145.5136,140.3339 C148.2626,138.1079 148.3826,116.7509 148.3826,113.0839 C148.3826,109.4169 129.2656,77.0649 129.2656,77.0649"
              id="Fill-60"
              fill="#684345"
            ></path>
            <path
              d="M130.0389,74.6801 L116.6989,96.4041 C116.6989,96.4041 142.7639,142.5601 145.5139,140.3341 C148.2629,138.1071 149.4249,112.7231 149.4249,109.0561 C149.4249,105.3891 130.0389,74.6801 130.0389,74.6801"
              id="Fill-62"
              fill="#A26764"
            ></path>
            <path
              d="M125.1796,184.8296 C127.6526,178.4736 125.8606,171.8426 121.1766,170.0206 C116.4916,168.1986 110.6906,171.8736 108.2176,178.2306 C105.7446,184.5866 107.5366,191.2166 112.2206,193.0396 C116.9046,194.8616 122.7066,191.1856 125.1796,184.8296"
              id="Fill-64"
              fill="#684345"
            ></path>
            <path
              d="M80.1457,253.1988 C74.8867,253.1988 53.1457,266.4178 53.1457,268.7878 C53.1457,271.1568 76.5717,284.3758 80.1457,284.3758 C83.7197,284.3758 106.4047,272.0848 107.1457,268.7878 C107.8867,265.4898 85.4047,253.1988 80.1457,253.1988"
              id="Fill-66"
              fill="#684345"
            ></path>
            <path
              d="M79.4509,277.011 C74.2399,273.169 63.2109,272.338 63.2109,272.338 L64.4129,296.549 C64.4129,296.549 77.4129,301.174 77.2519,300.299 C77.0909,299.424 79.4509,277.011 79.4509,277.011"
              id="Fill-68"
              fill="#B55D75"
            ></path>
            <path
              d="M107.1459,268.7874 L80.1459,284.3764 C80.1459,284.3764 76.7379,314.7824 80.1459,315.5524 C83.5529,316.3234 105.2739,303.4174 107.1639,299.9544 C109.0529,296.4904 107.1459,268.7874 107.1459,268.7874"
              id="Fill-70"
              fill="#C27D78"
            ></path>
            <path
              d="M53.1459,268.7874 C53.1459,268.7874 51.4049,297.2714 53.1459,299.9644 C54.8869,302.6564 77.0709,315.5524 80.1459,315.5524 C83.2199,315.5524 80.1459,284.3764 80.1459,284.3764 L53.1459,268.7874 Z"
              id="Fill-72"
              fill="#9A5F5F"
            ></path>
            <path
              d="M79.9886,282.3965 C76.1396,282.3965 54.1716,269.6015 54.1716,267.7145 C54.1716,265.8265 77.2486,253.0315 79.9886,253.0315 C82.7286,253.0315 105.8626,265.5325 105.8056,267.7145 C105.7486,269.8955 83.8376,282.3965 79.9886,282.3965 M79.9886,250.5875 C76.7926,250.5875 49.8736,265.5115 49.8736,267.7145 C49.8736,269.9165 75.4996,284.8405 79.9886,284.8405 C84.4776,284.8405 110.0366,270.2595 110.1036,267.7145 C110.1696,265.1695 83.1846,250.5875 79.9886,250.5875"
              id="Fill-74"
              fill="#9A5F5F"
            ></path>
            <path
              d="M50.1039,267.2601 C50.1029,267.2611 50.1009,267.2631 50.0989,267.2641 C50.0639,267.2961 50.0339,267.3431 50.0059,267.3961 C50.0329,267.3531 50.0679,267.3071 50.1039,267.2601"
              id="Fill-76"
              fill="#B5B7B6"
            ></path>
            <path
              d="M110.0604,267.5168 C110.0574,267.5138 110.0524,267.5098 110.0484,267.5058 C110.0774,267.5798 110.1044,267.6538 110.1034,267.7138 C110.0374,270.2588 84.4784,284.8408 79.9884,284.8408 C75.5264,284.8408 50.1974,270.1038 49.8884,267.7618 C49.7124,268.6418 49.8744,270.2608 49.8744,270.4348 C49.8744,272.6368 75.4994,287.5618 79.9884,287.5618 C84.4784,287.5618 110.0374,272.9808 110.1034,270.4348 C110.1094,270.2058 110.4584,267.9238 110.0604,267.5168"
              id="Fill-78"
              fill="#7F5253"
            ></path>
            <path
              d="M110.1031,270.4353 C110.1081,270.2333 110.3771,268.4533 110.1741,267.7453 L110.1031,267.7143 C110.0391,270.1683 86.2801,283.8083 80.5561,284.7813 L80.4531,284.8403 L80.3761,287.5283 C85.7571,286.8293 110.0391,272.9163 110.1031,270.4353"
              id="Fill-80"
              fill="#C68F8C"
            ></path>
            <path
              d="M88.9064,278.8057 C88.7464,278.8877 88.5884,278.9677 88.4294,279.0477 C88.5884,278.9677 88.7464,278.8877 88.9064,278.8057"
              id="Fill-82"
              fill="#C3C8C7"
            ></path>
            <path
              d="M87.8908,279.3196 C87.7378,279.3956 87.5868,279.4706 87.4358,279.5456 C87.5868,279.4706 87.7378,279.3956 87.8908,279.3196"
              id="Fill-84"
              fill="#C3C8C7"
            ></path>
            <path
              d="M89.9411,278.2693 C89.7711,278.3583 89.6041,278.4453 89.4351,278.5323 C89.6041,278.4443 89.7711,278.3583 89.9411,278.2693"
              id="Fill-86"
              fill="#C3C8C7"
            ></path>
            <path
              d="M86.8949,279.8102 C86.7539,279.8782 86.6129,279.9472 86.4749,280.0132 C86.6129,279.9472 86.7539,279.8792 86.8949,279.8102"
              id="Fill-88"
              fill="#C3C8C7"
            ></path>
            <path
              d="M95.7293,275.0588 C95.4893,275.1988 95.2473,275.3388 95.0053,275.4788 C95.2473,275.3388 95.4893,275.1988 95.7293,275.0588"
              id="Fill-90"
              fill="#C3C8C7"
            ></path>
            <path
              d="M94.6909,275.6597 C94.4619,275.7907 94.2329,275.9217 94.0019,276.0527 C94.2329,275.9217 94.4619,275.7907 94.6909,275.6597"
              id="Fill-92"
              fill="#C3C8C7"
            ></path>
            <path
              d="M92.621,276.8246 C92.395,276.9496 92.169,277.0746 91.944,277.1976 C92.169,277.0746 92.395,276.9496 92.621,276.8246"
              id="Fill-94"
              fill="#C3C8C7"
            ></path>
            <path
              d="M91.6014,277.3827 C91.2144,277.5927 90.8294,277.7987 90.4464,278.0017 C90.8294,277.7987 91.2144,277.5927 91.6014,277.3827"
              id="Fill-96"
              fill="#C3C8C7"
            ></path>
            <path
              d="M93.6569,276.2469 C93.4299,276.3749 93.2029,276.5019 92.9759,276.6289 C93.2029,276.5019 93.4299,276.3749 93.6569,276.2469"
              id="Fill-98"
              fill="#C3C8C7"
            ></path>
            <path
              d="M80.5296,282.3342 C80.4786,282.3432 80.4236,282.3562 80.3756,282.3632 C80.4236,282.3562 80.4786,282.3432 80.5296,282.3342"
              id="Fill-100"
              fill="#C3C8C7"
            ></path>
            <path
              d="M81.0581,282.2145 C80.9891,282.2325 80.9181,282.2525 80.8521,282.2675 C80.9181,282.2525 80.9881,282.2325 81.0581,282.2145"
              id="Fill-102"
              fill="#C3C8C7"
            ></path>
            <path
              d="M79.9837,282.3961 L79.9887,282.3961 L79.9927,282.3961 L79.9887,282.3961 L79.9837,282.3961"
              id="Fill-104"
              fill="#C3C8C7"
            ></path>
            <path
              d="M79.9886,253.0317 C77.2486,253.0317 54.1716,265.8267 54.1716,267.7137 C54.1716,268.6317 59.3606,272.1237 65.1366,275.4727 C61.0376,273.0957 57.2346,270.6457 55.3756,269.0977 C60.1356,265.2707 77.6246,255.7527 79.9886,255.7527 C82.3666,255.7527 100.1046,265.1697 104.7086,269.0817 C104.0166,269.6877 103.0266,270.4257 101.8356,271.2387 C104.2086,269.6187 105.7906,268.2967 105.8056,267.7137 C105.8626,265.5327 82.7286,253.0317 79.9886,253.0317"
              id="Fill-106"
              fill="#7F5253"
            ></path>
            <path
              d="M82.3153,281.812 C82.2243,281.845 82.1373,281.875 82.0503,281.906 C82.1373,281.875 82.2243,281.845 82.3153,281.812"
              id="Fill-108"
              fill="#C3C8C7"
            ></path>
            <path
              d="M83.0399,281.5368 C82.9499,281.5728 82.8649,281.6048 82.7769,281.6378 C82.8649,281.6048 82.9499,281.5728 83.0399,281.5368"
              id="Fill-110"
              fill="#C3C8C7"
            ></path>
            <path
              d="M83.8238,281.2162 C83.7578,281.2442 83.6968,281.2682 83.6318,281.2952 C83.6968,281.2682 83.7578,281.2442 83.8238,281.2162"
              id="Fill-112"
              fill="#C3C8C7"
            ></path>
            <path
              d="M84.8969,280.7465 C84.8189,280.7815 84.7379,280.8185 84.6619,280.8535 C84.7379,280.8185 84.8189,280.7815 84.8969,280.7465"
              id="Fill-114"
              fill="#C3C8C7"
            ></path>
            <path
              d="M81.6545,282.0387 C81.5715,282.0657 81.4895,282.0907 81.4105,282.1147 C81.4895,282.0907 81.5715,282.0657 81.6545,282.0387"
              id="Fill-116"
              fill="#C3C8C7"
            ></path>
            <path
              d="M85.9139,280.2787 C85.7919,280.3357 85.6679,280.3947 85.5479,280.4507 C85.6679,280.3947 85.7919,280.3357 85.9139,280.2787"
              id="Fill-118"
              fill="#C3C8C7"
            ></path>
            <path
              d="M71.1097,278.7634 C71.2627,278.8424 71.4127,278.9194 71.5647,278.9974 C71.4127,278.9194 71.2627,278.8424 71.1097,278.7634"
              id="Fill-120"
              fill="#C3C8C7"
            ></path>
            <path
              d="M72.1233,279.2834 C72.2683,279.3564 72.4103,279.4284 72.5533,279.4994 C72.4103,279.4284 72.2683,279.3564 72.1233,279.2834"
              id="Fill-122"
              fill="#C3C8C7"
            ></path>
            <path
              d="M73.1168,279.78 C73.2518,279.846 73.3848,279.912 73.5178,279.976 C73.3848,279.912 73.2518,279.846 73.1168,279.78"
              id="Fill-124"
              fill="#C3C8C7"
            ></path>
            <path
              d="M69.5978,277.9639 C69.9118,278.1329 70.2248,278.2989 70.5348,278.4619 C70.2248,278.2979 69.9118,278.1329 69.5978,277.9639"
              id="Fill-126"
              fill="#C3C8C7"
            ></path>
            <path
              d="M66.3862,276.1901 C66.6152,276.3201 66.8432,276.4491 67.0722,276.5771 C66.8432,276.4491 66.6142,276.3201 66.3862,276.1901"
              id="Fill-128"
              fill="#C3C8C7"
            ></path>
            <path
              d="M74.083,280.2485 C74.205,280.3065 74.328,280.3655 74.448,280.4225 C74.328,280.3655 74.205,280.3065 74.083,280.2485"
              id="Fill-130"
              fill="#C3C8C7"
            ></path>
            <path
              d="M68.5028,277.3704 C68.7098,277.4834 68.9168,277.5974 69.1228,277.7084 C68.9168,277.5974 68.7098,277.4834 68.5028,277.3704"
              id="Fill-132"
              fill="#C3C8C7"
            ></path>
            <path
              d="M65.3412,275.5917 C65.5852,275.7327 65.8302,275.8727 66.0762,276.0137 C65.8302,275.8737 65.5852,275.7327 65.3412,275.5917"
              id="Fill-134"
              fill="#C3C8C7"
            ></path>
            <path
              d="M67.4446,276.7857 C67.6606,276.9057 67.8756,277.0257 68.0916,277.1447 C67.8766,277.0267 67.6606,276.9057 67.4446,276.7857"
              id="Fill-136"
              fill="#C3C8C7"
            ></path>
            <path
              d="M75.049,280.7003 C75.143,280.7433 75.24,280.7893 75.333,280.8303 C75.24,280.7893 75.143,280.7433 75.049,280.7003"
              id="Fill-138"
              fill="#C3C8C7"
            ></path>
            <path
              d="M100.2282,272.3047 C98.9232,273.1477 97.4652,274.0407 95.9452,274.9327 C97.4662,274.0397 98.9212,273.1487 100.2282,272.3047"
              id="Fill-140"
              fill="#C3C8C7"
            ></path>
            <path
              d="M101.7724,271.2821 C101.5514,271.4331 101.3224,271.5861 101.0884,271.7421 C101.3234,271.5861 101.5504,271.4331 101.7724,271.2821"
              id="Fill-142"
              fill="#C3C8C7"
            ></path>
            <path
              d="M101.0013,271.7994 C100.7633,271.9564 100.5203,272.1154 100.2713,272.2774 C100.5213,272.1154 100.7633,271.9564 101.0013,271.7994"
              id="Fill-144"
              fill="#C3C8C7"
            ></path>
            <path
              d="M78.9219,282.2114 C78.9919,282.2304 79.0619,282.2494 79.1279,282.2654 C79.0619,282.2494 78.9919,282.2304 78.9219,282.2114"
              id="Fill-146"
              fill="#C3C8C7"
            ></path>
            <path
              d="M79.4509,282.3336 C79.5009,282.3426 79.5549,282.3556 79.6019,282.3626 C79.5549,282.3556 79.5009,282.3426 79.4509,282.3336"
              id="Fill-148"
              fill="#C3C8C7"
            ></path>
            <path
              d="M76.1721,281.2012 C76.1901,281.2092 76.2061,281.2152 76.2241,281.2232 C76.2061,281.2152 76.1901,281.2092 76.1721,281.2012"
              id="Fill-150"
              fill="#C3C8C7"
            ></path>
            <path
              d="M76.9509,281.5252 C77.0339,281.5582 77.1109,281.5882 77.1919,281.6192 C77.1109,281.5882 77.0339,281.5582 76.9509,281.5252"
              id="Fill-152"
              fill="#C3C8C7"
            ></path>
            <path
              d="M78.3298,282.0336 C78.4118,282.0606 78.4918,282.0856 78.5708,282.1106 C78.4918,282.0856 78.4118,282.0606 78.3298,282.0336"
              id="Fill-154"
              fill="#C3C8C7"
            ></path>
            <path
              d="M77.6722,281.804 C77.7602,281.837 77.8442,281.866 77.9292,281.896 C77.8442,281.866 77.7602,281.837 77.6722,281.804"
              id="Fill-156"
              fill="#C3C8C7"
            ></path>
            <path
              d="M26.4524,191.5553 L23.8264,190.5653 L50.5134,268.2743 C50.5134,268.2743 53.6244,268.6813 54.1714,267.7143 C54.7194,266.7473 26.4524,191.5553 26.4524,191.5553"
              id="Fill-158"
              fill="#684345"
            ></path>
            <path
              d="M44.6214,239.0099 C45.2494,238.4339 48.9054,241.0119 49.4134,243.0059 C49.6874,244.0829 49.7214,246.9839 49.7214,246.9839 C49.7214,246.9839 60.6564,250.7399 61.0974,251.3269 C61.5374,251.9149 59.7994,254.7359 59.7994,254.7359 C59.7994,254.7359 46.7014,249.7069 45.8064,248.5309 C44.2534,246.4929 43.8384,244.0359 44.1504,243.5719 C44.4614,243.1069 45.8164,243.8169 45.8164,243.8169 C45.8164,243.8169 43.9934,239.5859 44.6214,239.0099"
              id="Fill-160"
              fill="#F3B679"
            ></path>
            <path
              d="M71.5531,254.6664 C71.5531,254.6664 69.1671,257.9244 65.7091,257.9244 C62.2501,257.9244 59.3161,256.3364 59.1141,255.4244 C58.9131,254.5124 60.4611,250.5544 61.2051,250.4954 C65.4331,250.1594 71.5531,254.6664 71.5531,254.6664"
              id="Fill-162"
              fill="#EEA8B7"
            ></path>
            <path
              d="M59.7991,254.7363 C59.7991,254.7363 61.5371,251.9153 61.0971,251.3273 C60.9971,251.1943 60.3551,250.8973 59.4271,250.5193 C58.8701,251.0403 58.2461,252.2793 57.9841,254.0283 C59.0841,254.4613 59.7991,254.7363 59.7991,254.7363"
              id="Fill-164"
              fill="#D58F66"
            ></path>
            <path
              d="M62.6917,250.5595 C62.1807,250.4885 61.6797,250.4575 61.2047,250.4955 C60.4617,250.5545 58.9127,254.5125 59.1147,255.4245 C59.1817,255.7285 59.5577,256.1075 60.1497,256.4775 C60.7537,253.9735 61.5957,251.8115 62.6917,250.5595"
              id="Fill-166"
              fill="#B55D75"
            ></path>
            <path
              d="M49.7678,274.8373 C49.7738,274.7473 49.7868,274.6603 49.8038,274.5743 C49.7868,274.6593 49.7748,274.7473 49.7678,274.8373"
              id="Fill-168"
              fill="#E57472"
            ></path>
            <path
              d="M49.7828,275.3475 C49.7748,275.2925 49.7728,275.2385 49.7678,275.1845 C49.7718,275.2385 49.7768,275.2925 49.7828,275.3475"
              id="Fill-170"
              fill="#E57472"
            ></path>
            <path
              d="M72.1085,249.7448 C80.1395,250.1548 81.5565,277.1898 79.9905,278.3088 C78.4245,279.4268 65.4505,279.0148 61.0675,272.8248 C59.8685,271.1308 64.0775,249.3348 72.1085,249.7448"
              id="Fill-172"
              fill="#D47087"
            ></path>
            <path
              d="M75.1925,253.5695 C75.1925,253.5695 72.7895,256.3675 70.1495,255.8705 C67.4905,255.3705 68.0245,252.3055 68.0245,252.3055 L75.1925,253.5695 Z"
              id="Fill-174"
              fill="#B55D75"
            ></path>
            <path
              d="M74.7119,252.4847 C74.7119,252.4847 72.6629,255.8177 70.1499,254.8707 C68.1509,254.1177 68.8439,251.2057 68.8439,251.2057 L74.7119,252.4847 Z"
              id="Fill-176"
              fill="#EFA26E"
            ></path>
            <path
              d="M77.1548,268.5988 C77.4928,268.0538 80.3448,267.2498 80.9508,267.6898 C81.2248,267.8878 82.8328,271.9138 82.6868,273.0498 C82.5398,274.1848 75.6758,281.5248 75.6758,281.5248 C75.6758,281.5248 76.5028,281.9638 76.6088,282.3338 C76.9238,283.4358 74.6098,287.0948 73.5178,287.5278 C72.3288,287.9998 69.8818,287.0318 69.4128,286.3738 C68.8488,285.5818 68.5438,280.6048 70.8408,279.5458 C71.6938,279.1518 73.1168,279.7798 73.1168,279.7798 L78.3728,273.2318 C78.3728,273.2318 77.0038,268.8428 77.1548,268.5988"
              id="Fill-178"
              fill="#F3B679"
            ></path>
            <path
              d="M77.2872,254.9976 C78.7602,255.6736 83.8492,265.4816 82.6752,266.8976 C82.1202,267.5676 76.7092,268.9866 75.7772,268.6136 C74.8452,268.2406 73.5982,258.9766 74.2652,256.8086 C74.9332,254.6406 77.2872,254.9976 77.2872,254.9976"
              id="Fill-180"
              fill="#EEA8B7"
            ></path>
            <path
              d="M77.1548,268.5988 C77.4928,268.0538 80.3448,267.2498 80.9508,267.6898 C81.0378,267.7518 81.1928,268.1538 81.3918,268.7818 C80.2398,269.1968 78.5738,269.6258 77.3268,269.8168 C77.1748,269.1268 77.1038,268.6808 77.1548,268.5988"
              id="Fill-182"
              fill="#D58F66"
            ></path>
            <path
              d="M82.7121,265.204 C82.8941,266.007 82.9081,266.617 82.6761,266.898 C82.1211,267.568 76.7091,268.986 75.7771,268.613 C75.5851,268.537 75.3871,267.979 75.1921,267.141 C76.8971,267.059 81.3441,265.885 82.7121,265.204"
              id="Fill-184"
              fill="#B55D75"
            ></path>
            <path
              d="M58.0231,243.972 C61.1461,252.571 75.3511,254.88 79.0771,252.914 C84.1911,250.217 86.2361,243.008 86.2361,243.008 L86.2361,226.254 L61.2801,223.254 C61.2801,223.254 56.0721,238.599 58.0231,243.972"
              id="Fill-186"
              fill="#F3B679"
            ></path>
            <path
              d="M61.9497,239.0099 C61.9497,238.0719 61.4037,237.3109 60.7297,237.3109 C60.0557,237.3109 59.5097,238.0719 59.5097,239.0099 C59.5097,239.9479 60.0557,240.7089 60.7297,240.7089 C61.4037,240.7089 61.9497,239.9479 61.9497,239.0099"
              id="Fill-188"
              fill="#050000"
            ></path>
            <path
              d="M73.9818,244.7372 C73.9818,243.7992 73.4358,243.0382 72.7618,243.0382 C72.0878,243.0382 71.5418,243.7992 71.5418,244.7372 C71.5418,245.6752 72.0878,246.4362 72.7618,246.4362 C73.4358,246.4362 73.9818,245.6752 73.9818,244.7372"
              id="Fill-190"
              fill="#050000"
            ></path>
            <path
              d="M74.2657,249.5821 C74.2657,248.3591 75.0917,247.3671 76.1117,247.3671 C77.1307,247.3671 77.9577,248.3591 77.9577,249.5821 C77.9577,250.8051 77.1307,251.7971 76.1117,251.7971 C75.0917,251.7971 74.2657,250.8051 74.2657,249.5821"
              id="Fill-192"
              fill="#EB8E71"
            ></path>
            <path
              d="M86.2364,227.2958 L60.3144,226.3498 C59.7444,228.2858 59.0304,230.9198 58.4744,233.6238 C64.7404,235.9218 70.0384,232.8308 70.0384,232.8308 C70.0384,232.8308 68.6404,235.8008 69.4754,237.0808 C71.6874,240.4718 82.8774,236.6328 86.2364,235.3848 L86.2364,227.2958 Z"
              id="Fill-194"
              fill="#D58F66"
            ></path>
            <path
              d="M88.9872,223.0328 C88.9872,223.0328 88.9052,216.1618 87.8422,216.0798 C86.7792,215.9988 86.7792,221.5608 86.7792,221.5608 C86.7792,221.5608 82.6202,217.6528 76.1452,215.8348 C69.9452,214.0938 61.4402,214.4198 60.4402,215.1808 C58.0172,217.0218 61.8312,220.1698 61.8312,220.1698 C61.8312,220.1698 55.0412,218.9428 53.5692,221.2338 C50.4692,226.0558 57.0642,231.7518 61.2582,232.4088 C67.7202,233.4208 73.6092,229.9038 73.6092,229.9038 C73.6092,229.9038 69.6452,234.8268 71.4842,235.7358 C75.4092,237.6738 83.4252,232.2758 83.4252,232.2758 C83.4252,232.2758 78.5172,242.0098 80.9712,244.4638 C82.3692,245.8608 86.2362,243.0078 86.2362,243.0078 C86.2362,243.0078 88.2442,244.5138 89.4782,242.5818 C93.2402,236.6928 89.9692,226.5498 89.9692,226.5498 C89.9692,226.5498 94.0582,224.1778 94.0582,223.0328 C94.0582,221.8878 88.9872,223.0328 88.9872,223.0328"
              id="Fill-196"
              fill="#5C4555"
            ></path>
            <path
              d="M86.2365,243.0078 C86.2365,243.0078 88.8685,242.8818 89.3655,244.7408 C89.7385,246.1398 89.2265,248.4748 87.8095,249.1148 C86.3925,249.7538 83.6975,248.2088 83.6975,248.2088 L86.2365,243.0078 Z"
              id="Fill-198"
              fill="#F3B679"
            ></path>
            <path
              d="M60.4403,215.1804 C61.4403,214.4204 69.9453,214.0934 76.1453,215.8344 C82.6203,217.6534 86.7783,221.5604 86.7783,221.5604 C86.7783,221.5604 86.7793,215.9984 87.8423,216.0804 C88.9053,216.1624 88.9873,223.0324 88.9873,223.0324 C88.9873,223.0324 94.0583,221.8874 94.0583,223.0324 C94.0583,224.1784 89.9693,226.5504 89.9693,226.5504 C89.9693,226.5504 91.4153,231.0404 91.2763,235.7804 C88.6073,227.5524 87.6063,227.4734 85.6513,225.2074 C83.7193,222.9674 76.2673,217.5754 59.7563,217.3724 C59.5183,216.6084 59.6033,215.8164 60.4403,215.1804"
              id="Fill-200"
              fill="#463141"
            ></path>
            <path
              d="M78.6833,283.1648 L83.7283,180.7008 L85.9143,182.2068 L82.4223,282.3968 C82.4223,282.3968 82.5233,283.5758 81.3873,283.8348 C80.0723,284.1338 78.6833,283.1648 78.6833,283.1648"
              id="Fill-202"
              fill="#684345"
            ></path>
            <polygon
              id="Fill-204"
              fill="#684345"
              points="76.5648 215.9588 75.4658 185.1388 77.7348 183.9958 79.0378 216.8338"
            ></polygon>
            <path
              d="M122.9088,197.2787 L105.8058,267.7137 C105.8058,267.7137 106.8158,268.5477 107.6688,268.7877 C108.5218,269.0267 110.1028,267.7137 110.1028,267.7137 L125.7078,194.0487 L122.9088,197.2787 Z"
              id="Fill-206"
              fill="#684345"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: "BalloonIcon",
  props: ["width", "height"],
};
</script>

<style>
</style>